var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41797 13.4937H17.8878M13.6529 9.25879V17.7287",
    stroke: "#00A3FA",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4358 7.10058C27.4358 6.56125 27.2216 6.04402 26.8402 5.66266C26.4589 5.2813 25.9416 5.06705 25.4023 5.06705H12.1844L9.74416 1.81341C9.55474 1.56085 9.30912 1.35587 9.02676 1.21469C8.74439 1.0735 8.43303 1 8.11734 1H3.03353C2.4942 1 1.97697 1.21425 1.59561 1.59561C1.21425 1.97697 1 2.4942 1 3.03353V21.3353C1 21.8746 1.21425 22.3918 1.59561 22.7732C1.97697 23.1545 2.4942 23.3688 3.03353 23.3688H25.4023C25.9416 23.3688 26.4589 23.1545 26.8402 22.7732C27.2216 22.3918 27.4358 21.8746 27.4358 21.3353V7.10058Z",
    stroke: "#00A3FA",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateFolderIcon);
export default __webpack_public_path__ + "static/media/create-folder-icon.07e5d2c5b71d753d911b7d8ee28d7e4d.svg";
export { ForwardRef as ReactComponent };